export class Siret {
  public code: string;
  public valeur: string;

  constructor() {
  }
}
